import axios from 'axios';
import swal from 'sweetalert2';

const state = {

};

const getters = {

};

const actions = {
    async getRemediationBatches(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getRemediationBatchesUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async addRemediationBatch(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.addRemediationBatchUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async getRemediationApplications(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getRemediationApplicationsUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async getRemediationApplication(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.getRemediationApplicationUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async approveRemediationApplication(state, data) {// get admin units
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.approveRemediationApplicationUrl;
        const header = {Authorization: `Bearer ${authorizationToken}`};
        const response = await axios.post(url, data,{ headers: header });// make api call
        return response.data;
    },
    async viewRemediationDocument(state, data) {// fetch user document function
        const authorizationToken = state.rootState.url.authorizationToken;
        const url = state.rootState.url.viewRemediationDocumentUrl;
        const header = {'X-Remediation-Token': authorizationToken};
        try {
            const response = await axios.post(url, data,
                        { 
                            responseType: 'blob', 
                            headers: header 
                        });// make api call
            const blobUrl = URL.createObjectURL(
            new Blob([response.data], { type: 'application/pdf' })
            );

            window.open(blobUrl, '_blank');
            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
            return blobUrl;
        } catch (error) {
            let errorMsg = data.msg;
            if (error.response && error.response.data instanceof Blob) {
                try {
                    const text = await error.response.data.text();
                    const json = JSON.parse(text);
                    errorMsg = json.msg || json.message || text;
                } catch {
                    errorMsg = data.msg + ' ' + error.message;
                }
            } else {
                errorMsg = error.message || errorMsg;
            }
            swal.fire('Error!', error + ' - ' + errorMsg, 'error');
        }
    },
};

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
}